/**
 * Thao tác được phép theo trạng thái phiên bản module (ADR-0046 mục 2–3).
 *
 * Bản chặn thật nằm ở `module-registry` (`ModuleLifecycleService`,
 * `VendorController`). Giao diện chỉ dùng bản này để **ẩn** hành động không
 * làm được (ADR-UI-0005). **Sửa ở đây thì sửa cả bên Java**, và ngược lại.
 *
 * | Trạng thái | Duyệt | Từ chối |
 * | ---------- | ----- | ------- |
 * | DRAFT      |       |         |
 * | IN_REVIEW  | Có    | Có      |
 * | PUBLISHED  |       |         |
 * | REJECTED   |       |         |
 * | DEPRECATED |       |         |
 */
import type { ModuleVersion, TrangThaiPhienBan } from './types.ts';

const DUYET_DUOC: ReadonlySet<TrangThaiPhienBan> = new Set<TrangThaiPhienBan>(['IN_REVIEW']);

export function duyetDuoc(trangThai: TrangThaiPhienBan): boolean {
  return DUYET_DUOC.has(trangThai);
}

export function tuChoiDuoc(trangThai: TrangThaiPhienBan): boolean {
  return DUYET_DUOC.has(trangThai);
}

/** Độ dài tối thiểu của lý do từ chối — giữ cùng ngưỡng với `license.lyDo` (tránh lý do một chữ). */
export const LY_DO_TU_CHOI_TOI_THIEU = 5;
export const LY_DO_TU_CHOI_TOI_DA = 1000;

export function lyDoTuChoiHopLe(lyDo: string): boolean {
  const s = lyDo.trim();
  return s.length >= LY_DO_TU_CHOI_TOI_THIEU && s.length <= LY_DO_TU_CHOI_TOI_DA;
}

/** Trần dung lượng gói — khớp đệm tải lên 2 lượt × 50 MB đã thấy ở `modules/bao-cao/module.yaml`. */
export const GOI_TOI_DA_BYTE = 50 * 1024 * 1024;

export function goiQuaLon(tep: File): boolean {
  return tep.size > GOI_TOI_DA_BYTE;
}

/** Chỉ nhận `.zip` theo bố cục gói ở ADR-0045 mục 1 — đuôi tệp là gợi ý đầu tiên, server mới là chốt chặn thật. */
export function dungDinhDangGoi(tep: File): boolean {
  return tep.name.toLowerCase().endsWith('.zip');
}

/**
 * Gom danh sách phẳng `ModuleVersion[]` (trả về từ `GET /api/v1/platform/modules`)
 * theo `code`, mới nộp trước trong từng nhóm — dựng dữ liệu cho màn danh sách
 * module vì API không có endpoint liệt kê theo module cho nhóm nền tảng.
 */
export function gomTheoCode(
  phienBanList: ModuleVersion[],
): { code: string; name: string; vendor: string; phienBan: ModuleVersion[] }[] {
  const theoCode = new Map<string, ModuleVersion[]>();
  for (const pb of phienBanList) {
    const ds = theoCode.get(pb.code) ?? [];
    ds.push(pb);
    theoCode.set(pb.code, ds);
  }
  return Array.from(theoCode.entries()).map(([code, ds]) => {
    const sapXep = [...ds].sort((a, b) => b.submitted_at.localeCompare(a.submitted_at));
    const moiNhat = sapXep[0];
    return { code, name: moiNhat.name, vendor: moiNhat.vendor, phienBan: sapXep };
  });
}
